'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Shared SWR plumbing for `useApiQuery` and `useServiceQuery`:
 * - runs `doFetch` on mount (and whenever its identity changes)
 * - re-runs `doFetch` when the document becomes visible again, gated on
 *   `enabled && revalidateOnFocus`
 */
export function useQueryRevalidation(enabled, revalidateOnFocus, doFetch) {
  const $ = _c(8);
  let t0;
  let t1;
  if ($[0] !== doFetch) {
    t0 = () => {
      doFetch();
    };
    t1 = [doFetch];
    $[0] = doFetch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== doFetch || $[4] !== enabled || $[5] !== revalidateOnFocus) {
    t2 = () => {
      if (!enabled || !revalidateOnFocus) {
        return;
      }
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          doFetch();
        }
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    t3 = [enabled, revalidateOnFocus, doFetch];
    $[3] = doFetch;
    $[4] = enabled;
    $[5] = revalidateOnFocus;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
}